module.exports = __webpack_public_path__ + "static/media/Estampa_Card3.7a776b0a.png";